import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import EmergencyContact from '../../components/EmergencyContact'

const UserEmergency = () => {
  return (
    <UserLayout>
    <EmergencyContact />
    </UserLayout>
  )
}

export default UserEmergency
